/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { Filter } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import ResTable from 'models/api/table';
import {
    PasswordChange,
    PasswordOtherChange,
    UserAdd,
    UserChange,
    UserFilter,
    UserItem,
    UserTableItem,
} from 'models/api/users';

export const getUsersList = async (axios: AxiosInstance, params: Filter<UserFilter>) => {
    const resp = await axios.get<ResTable<UserTableItem>>('/accounts', { params });
    return resp.data;
};

export const getUser = async (axios: AxiosInstance, id: string | number) => {
    const { data } = await axios.get<UserItem>(`/accounts/${id}`);
    return data;
};

export const addUser = async (axios: AxiosInstance, item: UserAdd) =>
    await axios.post('/accounts', item);

export const changeUser = async (axios: AxiosInstance, item: UserChange) =>
    await axios.put(`/accounts/${item.id}`, item);

export const deleteUser = async (axios: AxiosInstance, id: string | number, crmSync: boolean) =>
    await axios.delete(`/accounts/${id}`, { params: { crmSync } });

export const restoreUser = async (axios: AxiosInstance, id: string | number, crmSync: boolean) =>
    await axios.put(`/accounts/restored/${id}`, null, { params: { crmSync } });

export const pingCrmApi = async (axios: AxiosInstance) => {
    const { data } = await axios.get(`/accounts/pingCrmApi`);
    return data;
};

export const changePassword = async (axios: AxiosInstance, item: PasswordChange) => {
    const { data } = await axios.put(`/accounts/password`, item);
    return data;
};

export const changeOtherPassword = async (
    axios: AxiosInstance,
    id: string | number,
    item: PasswordOtherChange
) => await axios.put(`/accounts/${id}/password`, item);

export const getUsersExcel = async (axios: AxiosInstance, params: Filter<UserFilter>) => {
    const { data } = await axios.get<Blob>('/accounts/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};
